import { ButtonHTMLAttributes } from 'react'

import { cn } from '@/libs/tw'

import { fontStyles } from '../typography/typographyUtils'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	style?: 'naturel' | 'primary' | 'secondary' | 'transparent'
}
export const Button = ({
	className,
	style = 'naturel',
	children,
	disabled = false,
	...rest
}: ButtonProps) => {
	return (
		<button
			className={cn(
				'px-23 flex min-h-[56px] items-center justify-center rounded-8 uppercase',
				style === 'naturel' && 'bg-naturel text-button-text',
				style === 'primary' && 'bg-primary text-naturel',
				style === 'secondary' && 'bg-secondary text-naturel',
				style === 'transparent' && ' border border-textColor text-textColor',
				fontStyles['p-ms-bold'],
				disabled && 'cursor-not-allowed opacity-50',
				className
			)}
			disabled={disabled}
			{...rest}
		>
			{children}
		</button>
	)
}
